import { create } from 'zustand';

export type LinkState = 'online' | 'offline' | 'degraded';

interface ConnectionState {
  browserOnline: boolean;
  /** Realtime channel state, reported by the WebSocket client. */
  realtime: 'connected' | 'connecting' | 'disconnected';
  lastSyncAt: string | null;
  latencyMs: number | null;
  setBrowserOnline: (online: boolean) => void;
  setRealtime: (state: ConnectionState['realtime']) => void;
  markSync: (latencyMs?: number) => void;
  link: () => LinkState;
}

/** Offline is a normal, visible, non-blocking state (CLAUDE.md §20). */
export const useConnectionStore = create<ConnectionState>((set, get) => ({
  browserOnline: typeof navigator === 'undefined' ? true : navigator.onLine,
  realtime: 'disconnected',
  lastSyncAt: null,
  latencyMs: null,
  setBrowserOnline: (browserOnline) => set({ browserOnline }),
  setRealtime: (realtime) => set({ realtime }),
  markSync: (latencyMs) =>
    set({
      lastSyncAt: new Date().toISOString(),
      ...(latencyMs === undefined ? {} : { latencyMs }),
    }),
  link() {
    if (!get().browserOnline) return 'offline';
    return get().realtime === 'connected' ? 'online' : 'degraded';
  },
}));

if (typeof window !== 'undefined') {
  window.addEventListener('online', () => useConnectionStore.getState().setBrowserOnline(true));
  window.addEventListener('offline', () => useConnectionStore.getState().setBrowserOnline(false));
}
